import React, { useState } from 'react';
import { X } from 'lucide-react';
import styles from './InputModal.module.css';

/**
 * 입력 모달
 * @param {Object} props
 * @param {string} props.title - 모달 제목
 * @param {string} props.label - 입력 필드 라벨
 * @param {string} props.placeholder - 입력 필드 플레이스홀더
 * @param {string} props.type - 입력 타입 (text, number)
 * @param {Function} props.onConfirm - 확인 버튼 클릭 핸들러
 * @param {Function} props.onCancel - 취소 버튼 클릭 핸들러
 * @param {string} props.confirmText - 확인 버튼 텍스트
 * @param {string} props.confirmColor - 확인 버튼 색상
 */
const InputModal = ({
  title,
  label,
  placeholder,
  type = 'text',
  onConfirm,
  onCancel,
  confirmText = '확인',
  confirmColor = '#2196F3',
}) => {
  const [value, setValue] = useState('');

  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!value.trim()) return;
    onConfirm(type === 'number' ? parseInt(value, 10) : value);
  };

  return (
    <div className={styles.overlay} onClick={handleBackdropClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>{title}</h3>
          <button className={styles.closeBtn} onClick={onCancel}>
            <X size={20} />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.body}>
            <label className={styles.label}>{label}</label>
            <input
              type={type}
              className={styles.input}
              placeholder={placeholder}
              value={value}
              onChange={e => setValue(e.target.value)}
              autoFocus
            />
          </div>
          <div className={styles.footer}>
            <button type="button" className={styles.cancelBtn} onClick={onCancel}>
              취소
            </button>
            <button
              type="submit"
              className={styles.confirmBtn}
              style={{ backgroundColor: confirmColor }}
              disabled={!value.trim()}
            >
              {confirmText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InputModal;
